import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { UserFunctionsInterface } from '../../../core';

@JsonObject('UserFunctions')
export class UserFunctions implements UserFunctionsInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Code', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('Description', StringAdapter, true)
    private _description: string = undefined;

    get id(): Id {
        return this._id;
    }

    get code(): Id {
        return this._code;
    }

    get description(): string {
        return this._description;
    }
}
